import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Logout = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      fill={fill}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      width={Sizes[size]}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5.93335 5.03991C6.14002 2.63991 7.37335 1.65991 10.0733 1.65991H10.16C13.14 1.65991 14.3333 2.85325 14.3333 5.83325V10.1799C14.3333 13.1599 13.14 14.3532 10.16 14.3532H10.0733C7.39335 14.3532 6.16002 13.3866 5.94002 11.0266"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M10 8H2.41333"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3.89996 5.7666L1.66663 7.99994L3.89996 10.2333"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

Logout.displayName = 'Logout';
